// mirrors BE conditional requirements in Person#citizenship_validation:
// citizenship must be answered; a US citizen must answer the naturalized question; a non-citizen must supply eligible
// immigration status only when the server requires it (immigrationStatusRequired — false on ME).
export const CITIZENSHIP_CODES = {
  CITIZENSHIP: 'citizenship_required',
  NATURALIZED: 'naturalized_required',
  IMMIGRATION: 'immigration_required'
}

// usCitizen / naturalized / eligibleImmigration - true | false | null (null = unanswered)
// immigrationStatusRequired                      - server flag, passed in from a data-* value
// returns an array of { valid, target, code } (always at least one entry)
export function validateCitizenship({
  usCitizen = null,
  naturalized = null,
  eligibleImmigration = null,
  immigrationStatusRequired = false
} = {}) {
  if (usCitizen === null)
    return [{ valid: false, target: "usCitizen", code: CITIZENSHIP_CODES.CITIZENSHIP }]
  if (usCitizen === true && naturalized === null)
    return [{ valid: false, target: "naturalized", code: CITIZENSHIP_CODES.NATURALIZED }]
  if (usCitizen === false && immigrationStatusRequired && eligibleImmigration === null)
    return [{ valid: false, target: "eligibleImmigration", code: CITIZENSHIP_CODES.IMMIGRATION }]
  return [{ valid: true, target: null, code: null }]
}
